// extracted by mini-css-extract-plugin
module.exports = {"item_title":"DocGrid_item_title__MJsK5","item_description":"DocGrid_item_description__JSAhU","item_titleLink":"DocGrid_item_titleLink__2ek0W"};